// import React from 'react';
// import { Card, CardContent, CardMedia, Typography, Button, Box } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import DOMPurify from 'dompurify';

// const BlogCard = ({ title, description, image, link }) => {
//   const navigate = useNavigate();

//   const handleReadMore = () => {
//     navigate(link);
//   };

//   return (
//     <Card
//       sx={{
//         maxWidth: 345,
//         borderRadius: 2,
//         boxShadow: 3,
//         '&:hover': {
//           transform: 'scale(1.05)',
//           boxShadow: 6,
//           transition: '0.3s',
//         },
//       }}
//     >
//       <CardMedia component="img" height="140" image={image} alt={title} />
//       <CardContent>
//         <Typography 
//           gutterBottom 
//           variant="h5" 
//           fontWeight="bold"
//           sx={{
//             display: '-webkit-box',
//             WebkitBoxOrient: 'vertical',
//             overflow: 'hidden',
//             WebkitLineClamp: 2,
//           }}
//         >
//           {title}
//         </Typography>
//         <Typography
//           variant="body2"
//           color="text.secondary"
//           sx={{
//             display: '-webkit-box',
//             WebkitBoxOrient: 'vertical',
//             overflow: 'hidden',
//             WebkitLineClamp: 3,
//           }}
//           dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
//         />
//       </CardContent>
//       <Box textAlign="center" mb={2}>
//         <Button variant="contained" color="primary" onClick={handleReadMore}>
//           Read More
//         </Button>
//       </Box>
//     </Card>
//   );
// };

// export default BlogCard;

import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify'; 

const BlogCard = ({ title, description, image, link }) => {
  const navigate = useNavigate();

  const handleReadMore = () => {
    navigate(link);
  };

  return (
    <Card
      sx={{
        maxWidth: 345,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        // backgroundColor:'pink',
        boxShadow: 3,
        '&:hover': {
          transform: 'scale(1.03)',
          boxShadow: 6,
          transition: '0.3s',
        },
      }}
    >
      <CardMedia component="img" height="140" image={image} alt={title} />
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography 
          gutterBottom 
          variant="h6" 
          component="div"
          fontWeight="bold"
          sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            WebkitLineClamp: 2,
            mb: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            WebkitLineClamp: 3,
            mb: 2,
            flexGrow: 1,
          }}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
        />
        <Box sx={{ mt: 'auto' }}>
          <Button variant="contained" color="primary" onClick={handleReadMore} fullWidth>
            Read More
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default BlogCard;

